module.exports = __webpack_public_path__ + "static/img/shopee.f8f6327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/shopee.png
// module id = J7qZ
// module chunks = 31